var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.countPages > 0
    ? _c("div", [
        _c(
          "nav",
          {
            staticClass: "pagination is-centered",
            attrs: { role: "navigation", "aria-label": "pagination" }
          },
          [
            _c(
              "ul",
              { staticClass: "pagination-list" },
              [
                _vm.prePage > 0
                  ? [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "pagination-link",
                            attrs: { href: _vm.createUrl(1) }
                          },
                          [_vm._v("First")]
                        )
                      ])
                    ]
                  : _vm._e(),
                _c("li", [
                  _vm.query.pageNo != 1 && _vm.query.pageNo != ""
                    ? _c(
                        "a",
                        {
                          staticClass: "pagination-previous",
                          attrs: {
                            href: _vm.createUrl(parseInt(_vm.currentPage) - 1)
                          }
                        },
                        [_vm._v("Previous")]
                      )
                    : _vm._e()
                ]),
                _vm._l(_vm.loopPage, function(i, index) {
                  return _c("li", { key: index }, [
                    _c(
                      "a",
                      {
                        staticClass: "pagination-link",
                        class: { "is-current": i == _vm.query.pageNo },
                        attrs: { href: _vm.createUrl(i) }
                      },
                      [_vm._v(_vm._s(i))]
                    )
                  ])
                }),
                _c("li", [
                  _vm.query.pageNo != this.countPages && _vm.query.pageNo != ""
                    ? _c(
                        "a",
                        {
                          staticClass: "pagination-next",
                          attrs: {
                            href: _vm.createUrl(parseInt(_vm.currentPage) + 1)
                          }
                        },
                        [_vm._v("Next page")]
                      )
                    : _vm._e()
                ]),
                _vm.subPage > 0
                  ? [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "pagination-link",
                            attrs: { href: _vm.createUrl(_vm.countPages) }
                          },
                          [_vm._v("Last")]
                        )
                      ])
                    ]
                  : _vm._e()
              ],
              2
            )
          ]
        ),
        _c(
          "div",
          {
            staticStyle: {
              "margin-top": "10px",
              "text-align": "center",
              display: "block"
            }
          },
          [
            _vm._v(
              "\n  Showing " +
                _vm._s(_vm.startText) +
                " to " +
                _vm._s(_vm.toText) +
                " of  " +
                _vm._s(_vm.datas.totalRows) +
                "\n\n"
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-290ef215", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290ef215","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pagination.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-290ef215","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pagination.vue
// module chunks = 18 19 20 21 22 23 24 25 26 27 28 39